import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";

function* getVendorResponse() {
    try {
        const response = yield call(getList, "/API/V1/Generic/GetVendor");
        if (response?.statusCode === 1200) {
            yield put(actions.getVendorSuccess(response.data));
        } else {
            yield put(actions.getVendorError(response.message));
        }
    } catch (error) {
        yield put(actions.getVendorError(error));
    }
}

function* getACodeResponse() {
    try {
        const response = yield call(getList, "/API/V1/Generic/GetACode");
        if (response?.statusCode === 1200) {
            yield put(actions.getACodeSuccess(response.data));
        } else {
            yield put(actions.getACodeError(response.message));
        }
    } catch (error) {
        yield put(actions.getACodeError(error));
    }
}

function* getPlanResponse({ payload: { data } }) {
    try {
        const response = yield call(getList, `/API/V1/Generic/GetPlan?ActionType=${data.ActionType}&Month=${data.Month}`);
        if (response?.statusCode === 1200) {
            yield put(actions.getPlanSuccess(response?.data));
        } else {
            yield put(actions.getPlanError(response?.message));
        }
    } catch (error) {
        yield put(actions.getPlanError(error));
    }
}

function* printDetailResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/Generic/GetPrintDetails", data);

        if (response?.statusCode === 1200) {
            yield put(actions.printDetailSuccess(response?.data));
        } else {
            yield put(actions.printDetailError(response?.message));
        }
    } catch (error) {
        yield put(actions.printDetailError(error));
    }
}

function* getBillingCodeListResponse({ payload: { data } }) {
    try {
        const response = yield call(getList, `/API/V1/Generic/GetBillingCode?ActionType=${data.ActionType}`);
        if (response?.statusCode === 1200) {
            yield put(actions.getBillingCodeSuccess(response?.data));
        } else {
            yield put(actions.getBillingCodeError(response?.message));
        }
    } catch (error) {
        yield put(actions.getBillingCodeError(error));
    }
}

function* getDashboardResponse({ payload: { data } }) {
    try {
        const response = yield call(getList, `/API/V1/Generic/GetDashboard?ActionType=${data?.actionType}`);
        if (response?.statusCode === 1200) {
            yield put(actions.getDashboardDataSuccess(response?.data));
        } else {
            yield put(actions.getDashboardDataError(response?.message));
        }
    } catch (error) {
        yield put(actions.getDashboardDataError(error));
    }
}

function* getUserPanelAccessResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/Generic/FetchPanelAccess", data);
        if (response?.statusCode === 1200) {
            yield put(actions.getUserPanelAccessSuccess(response?.data));
        } else {
            yield put(actions.getUserPanelAccessSuccess(response?.message || "Failed to get user panel access list"));
        }
    } catch (error) {
        yield put(actions.getUserPanelAccessSuccess(error?.message || error)
        );
    }
}


export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_VENDOR, getVendorResponse),
        takeEvery(actions.GET_ACODE, getACodeResponse),
        takeEvery(actions.GET_PLAN, getPlanResponse),
        takeEvery(actions.GET_BILLING_CODE, getBillingCodeListResponse),
        takeEvery(actions.PRINT_DETAILS, printDetailResponse),
        takeEvery(actions.GET_DASHBOARD, getDashboardResponse),
         takeEvery(actions.GET_USER_PANEL_ACCESS, getUserPanelAccessResponse),
    ]);
}